import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const LightTooltip = withStyles(theme => ({
	tooltip: {
		backgroundColor: `${theme.palette.secondary.main} !important`,
		color: '#0F0F0F !important',
		borderRadius: '0px !important',
		boxShadow: theme.shadows[1],
		fontSize: '11px !important',
		padding: '0px !important',
		top: theme.spacing(-1),
		minWidth: props => (props.notification === 'notificationCenter' ? theme.spacing(37) : theme.spacing(30)),
		pointerEvents: 'auto'
	},
	arrow: {
		color: `${theme.palette.secondary.main} !important`
	}
}))(Tooltip);

export default LightTooltip;
